import apiInternal from './servers/apiInternal';

export interface PushReprocessResponse {
  success: boolean;
  data: Array<{
    id: string;
    status?: string;
    message: string;
    secret?: boolean;
  }>;
}

const pushReprocess = {
  reprocess: async ({ cnjIds }: { cnjIds: string[] }): Promise<PushReprocessResponse> => {
    const res = await apiInternal.post(`/push/reprocessar`, {
      cnjIds,
    });
    // O backend retorna { success: true, data: [...] }
    // Garantimos que sempre retornamos no formato esperado
    if (res.data && res.data.success !== undefined && res.data.data) {
      return res.data;
    }
    // Fallback caso a resposta venha em formato diferente
    return {
      success: true,
      data: Array.isArray(res.data) ? res.data : [],
    };
  },
};

export default pushReprocess;

